import React, { useState, useEffect } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { Button } from '@material-ui/core';
import clsx from 'clsx';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      background: theme.brand,
      color: 'white',
      '&:hover': {
        background: '#600101',
      },
    },
    typography: {
      padding: theme.spacing(2),
      width: '400px',
      height: '200px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      alignItems: 'center',
    },
    btnGroup: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'space-around',
    },
    btn: {
      width: '30%',
      backgroundColor: '#027AC5',
      borderRadius: '5px',
      color: '#fff',
    },
    gray: {
      backgroundColor: 'gray',
    },
  })
);

export default function EndCallButton(props: { className?: string }) {
  const classes = useStyles();
  const { room } = useVideoContext();

  const handleEndCall = () => {
    window.sessionStorage.setItem('endSession', 'true');
    room!.disconnect();
  };

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [agentCall, setAgentCall] = useState<boolean>(false);

  useEffect(() => {
    const searchStr = window.sessionStorage.getItem('searchStr');
    if (!!searchStr) {
      const searchParams = new URLSearchParams(searchStr);
      const isAgentCall = searchParams.get('isAgentCall');
      const agentName = searchParams.get('name');
      const agentRoom = searchParams.get('room');
      if (isAgentCall === 'true' && !!agentRoom && !!agentName) {
        setAgentCall(true);
      }
    }
  }, []);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const { innerHeight, innerWidth } = window;
  const positionLeft = innerWidth / 2 - 200;
  const positionTop = innerHeight / 2 - 100;

  return (
    <>
      <Button
        onClick={agentCall ? handleEndCall : handleClick}
        className={clsx(classes.button, props.className)}
        data-cy-disconnect
      >
        Disconnect
      </Button>
      {!agentCall && (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          anchorPosition={{ left: positionLeft, top: positionTop }}
          anchorReference="anchorPosition"
        >
          <Typography className={classes.typography}>
            <p>Are you sure you want to disconnect?</p>
            <div className={classes.btnGroup}>
              <Button className={classes.btn} onClick={handleEndCall}>
                Yes
              </Button>
              <Button className={`${classes.btn} ${classes.gray}`} onClick={handleClose}>
                No
              </Button>
            </div>
          </Typography>
        </Popover>
      )}
    </>
  );
}
